import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';

export const TabList = styled.ul<{ hasSidebar?: boolean }>`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black_10};
  overflow: scroll;
  max-width: 1024px;
  margin-bottom: 2rem;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    overflow-x: scroll;
    margin-bottom: 1rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    ${({ hasSidebar }) =>
      hasSidebar &&
      css`
        margin-top: ${({ theme }) => theme.spacing.three_2};
      `}
  }
`;

export const MobileWrapperPositionFixed = styled.div<{ isPositionFixed?: boolean }>`
  background-color: ${({ theme }) => theme.colors.black_5};

  ${({ isPositionFixed }) =>
    isPositionFixed &&
    `   position: fixed;
        top: 4rem;
        width: 100%;
        z-index: 2;
    `}
`;

export const TabItem = styled.li<{ disabled?: boolean; selected?: boolean }>`
  margin-right: ${({ theme }) => theme.spacing.zero_2};
  padding: ${({ theme }) => `${theme.spacing.zero_2} ${theme.spacing.one_2}`};

  color: ${({ theme, disabled }) => (disabled ? theme.colors.black_40 : theme.colors.black_100)};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  line-height: ${({ theme }) => theme.lineHeight.one};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  white-space: nowrap;

  list-style: none;
  cursor: pointer;

  user-select: none;

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'inherit')};
  :first-child {
    margin-left: ${({ theme }) => theme.spacing.zero_2};
  }
  ${({ selected }) =>
    selected &&
    css`
      border-bottom: 2px solid blue;
      border-color: ${({ theme }) => theme.colors.primary};

      font-family: ${({ theme }) => theme.fontFamily.semiBold};
    `}
`;

export const BackIcon = styled(Link)`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.one_2};

  :hover {
    svg path {
      stroke: ${({ theme }) => theme.colors.black_80};
    }
  }
`;

export const TabsWrapper = styled.div<{
  margin?: string;
  mobileMargin?: string;
  gap?: string;
  mobileGap?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    gap: ${({ mobileGap }) => mobileGap};
  }

  > div > ul {
    margin: ${({ margin }) => margin};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: ${({ mobileMargin }) => mobileMargin && mobileMargin};
  }
`;
